var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"login"},[_c('div',[_c('button',{on:{"click":function($event){_vm.handleAuthorize(true)}}},[_vm._v("同意")]),_c('button',{on:{"click":function($event){_vm.handleAuthorize(false)}}},[_vm._v("拒绝")])])])}
var staticRenderFns = []

export { render, staticRenderFns }